<template>
  <div class="rich-editor">

    <quill-editor
      v-model="innerContent"
      :options="quillOptions">
      <div id="toolbar" slot="toolbar">
        <div class="divider">
          <select class="ql-header">
            <option value="1">見出し1</option>
            <option value="2">見出し2</option>
            <option value="3">見出し3</option>
            <option value="4">見出し4</option>
            <option selected>段落</option>
          </select>
        </div>
        <div class="divider">
          <select class="ql-size">
            <option value="small">小</option>
            <option selected>普通</option>
            <option value="large">大</option>
            <option value="huge">最大</option>
          </select>
        </div>
        <div class="divider">
          <button class="ql-bold"></button>
          <button class="ql-italic"></button>
          <button class="ql-underline"></button>
          <button class="ql-strike"></button>
          <select class="ql-background"></select>
          <select class="ql-color"></select>
          <select class="ql-align"></select>
        </div>
        <div class="divider">
          <button class="ql-blockquote"></button>
          <button class="ql-code-block"></button>
        </div>
        <div class="divider">
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
        </div>
        <div class="divider">
          <button class="ql-link"></button>
          <button class="ql-image"></button>
          <button class="ql-video"></button>
        </div>
        <div class="">
          <button class="ql-clean"></button>
        </div>
      </div>
    </quill-editor>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Quill from 'quill'
import { quillEditor } from 'vue-quill-editor'
import ImageResize from 'quill-image-resize-module'

Quill.register('modules/imageResize', ImageResize)

export default {
  data() {
    return {
      quillOptions: {
        modules: {
          toolbar: '#toolbar',
          imageResize: {
            modules: [ 'Resize', 'DisplaySize' ],
          },
        },
        placeholder: 'ここに説明を入力して下さい',
      },
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    }
  },
  mounted() {

  },
  computed: {
    innerContent: {
      get() {
        return this.content
      },
      set(value) {
        this.$emit('update:content', value)
      },
    },
  },
  methods: {

  },
  components: {
    quillEditor,
  },
}
</script>

<style lang='scss' scoped>
#toolbar {
  .divider:after {
    content: "";
    display: inline-block;
    float: left;
    width: 1px;
    height: 16px;
    margin: 4px 15px;
    background-color: #999;
  }
}
</style>
